import React, { useState } from 'react';
import { useTranslateFn } from '../../../utils/useTranslateFn';
import { TranslationKey } from '../../utils/text-translations';

export const Item = ({
  title,
  onClick,
  image,
  label,
  className,
  description,
}:
        {
            title?: string | React.ReactNode,
            className?: string,
            onClick: () => void,
            image?: string,
            description?: string,
            label: string
        }) => {
  const [open, setOpen] = useState<boolean>(false);
  const toggle = () => setOpen((o) => !o);
  const t = useTranslateFn<TranslationKey>();

  return (
    <div className={`item ${className}`}>
      {/* eslint-disable-next-line */}
        <a onClick={onClick}>{label}</a>
      <div>
        {image && <img src={image} alt="" />}
        <div>{title}</div>
        {description && (
          !open
            ? <button type="button" onClick={toggle}>{t('texts.btn.showMore')}</button>
            : <button type="button" onClick={toggle}>{t('texts.btn.showLess')}</button>
        )}
      </div>
      {open && description && <div className="description">{description}</div>}
    </div>
  );
};
